<!-- eslint-disable max-len -->
<template>
	<div data-e2e="global-placeholder-bottom">
		<noscript v-if="false && this.isVitalsorCare">
			<img
			alt=""
			height="1"
			width="1"
			style="display:none"
			src="https://www.facebook.com/tr?id=428750600651790&ev=PageView&noscript=1"
			/>
		</noscript>
		<noscript v-if="false && !this.isVitalsorCare">
			<img
			alt=""
			height="1"
			width="1"
			style="display:none"
			src="https://www.facebook.com/tr?id=428750600651790&ev=PageView&noscript=1"
			/>
			<img
			alt=""
			height="1"
			width="1"
			style="display:none"
			src="https://ct.pinterest.com/v3/?tid=2618142259440&noscript=1"
			/>
			<img
			alt=""
			height="1"
			width="1"
			style="display:none"
			src="https://ct.pinterest.com/v3/?tid=2618142259440&event=pagevisit&noscript=1"
			/>
			<img
			alt=""
			height="1"
			width="1"
			style="border-style:none"
			src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/875612316/?guid=ON&amp;script=0"
			/>
		</noscript>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import debug from 'webmd-debug';
import { googleRemarketingCode } from './assets/legacy-script-google-remarketing.es6';
import { socialPixelsCode }  from './assets/legacy-script-social-pixels.es6';
import responsivePos5000Outstream from './assets/responsive-outstream-pos-5000.es6';

export default {
	name: 'GlobalPlaceHolderBottom',
	props: {
		chronicId: {
			type: String,
		},
	},
	data() {
		return {
			isVitalsorCare: false,
			isDrugsOrCareOrSymptomChecker: false,
			isRemarketingBlocked: false,
		};
	},
	computed: {
		isOncology() {
			return this.store.pagedata.isOncology;
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.store.cms.SET_RENDERED(this.chronicId);
		if (!this.isOncology) {
			this.store.cms.SET_RENDERED('shared_object.Bundle_Article_Data');
		}
	},
	methods: {
		getSocialScripts() {
			socialPixelsCode(debug);
		},
	},
	mounted() {
		/*
		 * To get the domain and fire the Pixel events
		 * For Vitals and Care FB pixel only be fired
		 */
		var self = this;
		 let excludeTopics = ['1634', '1663', '1664', '1669', '1695', '1700', '1703', '1705', '1707', '1709', '1711', '1719', '1756', '1760', '1761', '1762', '1783', '1814', '1818', '1819', '1835', '1840', '2730', '2756', '2857', '2950', '2952', '2953', '3079', '3236', '3539', '3540', '3541', '3552', '3571', '3607', '3608', '3623', '3631', '3637', '3644', '3838', '3927', '3928', '3930', '3937', '3939', '3950', '3951', '3954', '3958', '3962', '3963', '3965', '3966', '3971', '3989', '4010', '4048', '4049', '4050', '4052', '4058', '4099', '4119', '4121', '4140', '4203', '4222', '4227', '4228', '4236', '4242', '4251', '4254', '4257', '5555', '6041', '18091', '18092', '18093', '18094', '4298', '1678', '2949', '2948', '2947', '1624', '1833', '1674', '4249', '1628', '2951', '1626', '3554', '3553', '4272', '1633', '3624', '3625', '3610'];
		if (window.s_pagename && ((window.s_pagename.indexOf('doctor.webmd.com') > -1 || window.s_pagename.indexOf('doctor.staging.webmd.com') > -1) || (window.s_pagename.indexOf('vitals.com') > -1 || window.s_pagename.indexOf('staging.vitals.com') > -1))) {
			this.isVitalsorCare = true;
		}

		if (window.s_pagename && (window.s_pagename.indexOf('drugs/') > -1 || window.s_pagename.indexOf('doctor.') > -1 || window.s_pagename.indexOf('symptoms.') > -1)) {
			this.isDrugsOrCareOrSymptomChecker = true;
		}

		// check for vendor blocking
		// eslint-disable-next-line no-underscore-dangle
		if (window.globalConfig && window.globalConfig.ads) {
			// eslint-disable-next-line no-underscore-dangle
			const { vendorConfig } = window.globalConfig.ads;
			if (vendorConfig && vendorConfig.g_remarketing && vendorConfig.g_remarketing.disable
				&& vendorConfig.g_remarketing.disable === true) {
				this.isRemarketingBlocked = true;
			}
		}
		if(window.s_topic && excludeTopics.includes(window.s_topic)){
				this.isRemarketingBlocked = true;
		}

		/*
		 * Google Code for Remarketing Tag
		 * Remarketing tags may not be associated with personally identifiable information or
		 * placed on pages related to sensitive categories. See more information and instructions on
		 * how to setup the tag on: http://google.com/ads/remarketingsetup
		 */
		const googlePageAd = document.createElement('script');
		googlePageAd.setAttribute('data-e2e', 'external-googlepagead');
		googlePageAd.setAttribute('src', '//www.googleadservices.com/pagead/conversion_async.js');
		googlePageAd.async = true;
		if (!this.isDrugsOrCareOrSymptomChecker && !this.isRemarketingBlocked) {
			if (window.s_sensitive === undefined || (window.s_sensitive && window.s_sensitive === 'false')) {
				document.body.appendChild(googlePageAd);
			}
		}

		/*
		 * Google Remarketing must be loaded after the googlePageAd script
		 */
		 if (!this.isDrugsOrCareOrSymptomChecker && !this.isRemarketingBlocked) {
			if (window.s_sensitive === undefined || (window.s_sensitive && window.s_sensitive === 'false')|| (window.location && window.location.search.has('conmktvid'))) {
				googleRemarketingCode();
			}
		}

		if (!this.isDrugsOrCareOrSymptomChecker) {
			 Promise.resolve(window.__tcfapiPromise).then(function () {
				 self.getSocialScripts();
			 })
			
		}

		// on document loaded fire responsivePos5000Outstream
		if (!this.isVitalsorCare) {
			document.addEventListener('DOMContentLoaded', () => {
				responsivePos5000Outstream();
			});
		}

		document.addEventListener('infinite-article-visible', () => {
			if (window.fbq) {
				window.fbq('track', 'PageView');
			}
			if (!this.isVitalsorCare) {
				if (window.twq) {
					window.twq('track', 'PageView');
				}

				if (window.pintrk) {
					window.pintrk('page');
					window.pintrk('track', 'pagevisit');
				}

				if (window.rdt) {
					window.rdt('track', 'PageVisit');
				}
			}
		});

		if (!this.isDrugsOrCareOrSymptomChecker) {
			if (window.s_sensitive === undefined || (window.s_sensitive && window.s_sensitive === 'false')) {
				document.addEventListener('infinite-page-loaded', () => {
					if (window.s_topic) {
						window.gtag('event', 'page_view', {
							send_to: 'AW-875612316',
							pt: window.s_topic,
						});
					}
				});
			}
		}
	},
};
</script>
<style lang="scss" scoped></style>
